import { ContractStepperEnum } from 'v3/data/store/contractCard/stepper/enum';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';

export const completedStepsByContractingStatus = (
  contractingState: ContractingStateEnum,
  hasDevice: boolean,
  flagOn?: Boolean,
  dowloadPreContractAvailable?: boolean,
): Array<ContractStepperEnum> => {
  const preContractStateIsCompleted = (flagOn && !dowloadPreContractAvailable) || hasDevice;
  const stepCompletionMap = {
    [ContractingStateEnum.ContractingFinished]: [
      ContractStepperEnum.TokenStep,
      ContractStepperEnum.DeviceDetails,
      ContractStepperEnum.ContractSignature,
      ...(flagOn ? [ContractStepperEnum.PreContract] : []),
    ],
    [ContractingStateEnum.ProcessingAntiFraud]: [
      ContractStepperEnum.TokenStep,
      ...(flagOn ? [ContractStepperEnum.PreContract] : []),
      ...(hasDevice ? [ContractStepperEnum.DeviceDetails] : []),
    ],
    [ContractingStateEnum.WaitingContractEffectiveness]: [
      ContractStepperEnum.TokenStep,
      ...(preContractStateIsCompleted ? [ContractStepperEnum.PreContract] : []),
      ...(hasDevice ? [ContractStepperEnum.DeviceDetails] : []),
    ],
  };

  return stepCompletionMap[contractingState] || [];
};
